module.exports = __webpack_public_path__ + "assets/prevTaskBtn.8886166a6fb82db89a529338141b534c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/play-screen-ui/prevTaskBtn.svg
// module id = 188
// module chunks = 0